module.exports = __webpack_public_path__ + "static/media/Ειδικο  Δημ Σχολ Κωφων Λυκοβρυσης.b23ba59c.vtt";